import React from 'react';
import Select from '../../../engine/SelectEngine';
import Animation from '../../../Animation';
import Tooltip from '@material-ui/core/Tooltip';
import useTranslations from '../../../../hooks/useTranslations';
import UsersInputBoxEngine from '../../../engine/UsersInputBoxEngine';
import Colors from '../../../../internal-components/Colors';
import { SimpleFlexContainer } from '../../../layouts/ng-layouts/Containers';

const userSelectCSS = `
    & > div {
        border-color: ${Colors.BORDER_GREY};
        border-radius: 6px;
        min-height: 36px !important;
        margin-left: 0.8rem;
    }
`;

const SelectUsersView = props => {
  const t = useTranslations();
  return (
    <SimpleFlexContainer>
      <SimpleFlexContainer $row $containerCSS={props.containerCSS}>
        <Select
          variant={props.variant}
          customCSS={props.customCSS || 'margin-left: 0.8rem !important;'}
          value={props.shareTypeValue}
          onChange={props.onTypeChange}
          options={props.filteredOptions}
        />
        <span>
          <Animation
            type="collapse"
            in={props.shareTypeValue === 'user_lookup'}
          >
            <Tooltip
              arrow
              title={
                !props.userLookupFields || !props.userLookupFields.length
                  ? 'Please add user lookup fields'
                  : ''
              }
            >
              <span>
                <Select
                  disabled={
                    !props.userLookupFields || !props.userLookupFields.length
                  }
                  variant={props.variant}
                  placeholder={'Choose field'}
                  customCSS="margin-left: 0.8rem !important;"
                  value={props.lookupFieldId}
                  onChange={value =>
                    props.update({
                      lookupFieldId: value
                    })
                  }
                  options={props.userLookupFields.map(f => ({
                    value: f.internalId,
                    text: f.title || 'Untitled user lookup field',
                    'data-testid': `lookup-${f.internalId}`
                  }))}
                />
              </span>
            </Tooltip>
          </Animation>
          {props.useMultiUserSelect ? null : (
            <Animation
              type="collapse"
              in={props.shareTypeValue !== 'user_lookup'}
            >
              <Select
                searchable
                customCSS="margin-left: 0.8rem !important;"
                data-testid="user-select"
                value={props.assignedUserData}
                placeholder={
                  props.assignedUserData.value
                    ? `${props.assignedUserData.data.firstName} ${props.assignedUserData.data.lastName}`
                    : 'Choose user'
                }
                valueParser={val => (val.value ? val.value : val)}
                openMenuOptionParser={opt => {
                  return (
                    <p style={{ margin: 0 }}>
                      {opt.value.data.firstName + ' ' + opt.value.data.lastName}
                      <br />
                      <small>{opt.value.data.email}</small>
                    </p>
                  );
                }}
                onChange={res => {
                  props.setAssignedUserData({ ...res });
                  props.update({
                    userId: res.value
                  });
                }}
                asyncOptions={searchValue =>
                  props.getMatchingUsers(searchValue)
                }
              />
            </Animation>
          )}
        </span>
      </SimpleFlexContainer>
      {props.useMultiUserSelect ? (
        <>
          <Animation
            type="collapse"
            in={props.shareTypeValue === 'specific_user'}
          >
            <UsersInputBoxEngine
              value={props.users4MultiSelect}
              onChange={res => {
                const ids = res ? res.map(id => id.value) : undefined;
                props.setUsers4MultiSelect(res);
                props.update({
                  userId: undefined,
                  userIds: ids
                });
              }}
              customCSS={userSelectCSS}
              placeholder={t('automaions.wizard.actions.users.placeholder')}
            />
          </Animation>
          <Animation
            type="collapse"
            in={props.shareTypeValue === 'specific_admin'}
          >
            <Select
              customCSS="margin-left: 0.8rem !important; margin-top: 0 !important; margin-bottom: 0 !important; width: calc(100% - 0.8em);"
              disabled={!props.formAdmins.length}
              placeholder={t('automaions.wizard.actions.admins.placeholder')}
              value={props.users4MultiSelect}
              allowMultiSelect
              onChange={values => {
                props.setUsers4MultiSelect(values);
                props.update({
                  userId: undefined,
                  userIds: values.length ? values : undefined,
                  admin: true
                });
              }}
              options={props.formAdmins.map(a => ({
                value: a.user_id,
                text: `${a.info.firstName} ${a.info.lastName}`,
                'data-testid': `select-admin-${a.user_id}`
              }))}
            />
          </Animation>
        </>
      ) : null}
    </SimpleFlexContainer>
  );
};

export default SelectUsersView;
